var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.629,
    height: 13.652,
    viewBox: "0 0 13.629 13.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-call",
    d: "M13.1,6.255a.569.569,0,0,1-.569-.569,4.554,4.554,0,0,0-4.55-4.55A.569.569,0,0,1,7.977,0a5.693,5.693,0,0,1,5.687,5.687A.569.569,0,0,1,13.1,6.255Zm-1.706-.569A3.412,3.412,0,0,0,7.977,2.274a.569.569,0,1,0,0,1.137,2.275,2.275,0,0,1,2.275,2.275.569.569,0,0,0,1.137,0ZM12.631,12.6l.518-.6a1.763,1.763,0,0,0,0-2.489c-.018-.018-1.386-1.07-1.386-1.07a1.763,1.763,0,0,0-2.435,0l-1.084.913A7.27,7.27,0,0,1,4.3,5.416l.91-1.081a1.763,1.763,0,0,0,0-2.435S4.162.533,4.144.516A1.753,1.753,0,0,0,1.684.489l-.654.569C-2.834,5.541,5.486,13.8,10.117,13.648A3.5,3.5,0,0,0,12.631,12.6Z",
    transform: "translate(-0.035 0.002)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.2a6dd7978e89b17c5ff8a5baa60d42de.svg";
export { ForwardRef as ReactComponent };